import { BBDTag, Horizontal, Texto } from '@gravitate-js/excalibrr'
import React from 'react'

interface SingleProductGroupCellRendererProps {
  value: string
}

/**
 * Renders a single product group tag with appropriate styling
 */
export function SingleProductGroupCellRenderer({ value }: SingleProductGroupCellRendererProps): JSX.Element {
  if (value === 'Ethanol')
    return (
      <BBDTag style={{ minWidth: 'fit-content', fontSize: '10px' }} className='mr-0 px-2' color='blue'>
        {value}
      </BBDTag>
    )
  if (value === 'Gasoline')
    return (
      <BBDTag style={{ minWidth: 'fit-content', fontSize: '10px' }} className='mr-0 px-2' color='black'>
        {value}
      </BBDTag>
    )
  if (value === 'Diesel')
    return (
      <BBDTag style={{ minWidth: 'fit-content', fontSize: '10px' }} className='mr-0 px-2' color='yellow'>
        {value}
      </BBDTag>
    )
  if (value === 'BioDiesel')
    return (
      <BBDTag style={{ minWidth: 'fit-content', fontSize: '10px' }} className='mr-0 px-2' color='orange'>
        {value}
      </BBDTag>
    )
  return <BBDTag style={{ minWidth: 'fit-content', fontSize: '10px' }}>{value}</BBDTag>
}

interface MultipleProductGroupCellRendererProps {
  value: string[]
}

/**
 * Renders multiple product group tags with appropriate sorting and styling
 */
export function MultipleProductGroupCellRenderer({ value }: MultipleProductGroupCellRendererProps): JSX.Element {
  if (!value) return <Texto appearance='hint'>N/A</Texto>

  return (
    <Horizontal gap={4} style={{ overflow: 'visible' }}>
      {value
        .sort((a, b) => {
          // Sort values in the following order: Gasoline, Ethanol, Diesel, BioDiesel
          if (a === 'Gasoline') return -1
          if (b === 'Gasoline') return 1
          if (a === 'Ethanol') return -1
          if (b === 'Ethanol') return 1
          if (a === 'Diesel') return -1
          if (b === 'Diesel') return 1
          return a.localeCompare(b, undefined, {
            numeric: true,
            sensitivity: 'base',
          })
        })
        .map((product) => {
          return <SingleProductGroupCellRenderer key={product} value={product} />
        })}
    </Horizontal>
  )
}
